import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ContentCreatorInvite from './content-creator-invite-model'
import {
  CreateContentCreatorInviteAsync,
  DeleteContentCreatorInviteAsync,
  LoadContentCreatorInvitesAsync,
} from './contentCreatorInvite-thunk'
const initialState: contentCreatorInviteSliceState = {
  contentCreatorInvite: [],
  selected_contentCreatorInvite: '',
  is_loading_contentCreatorInvite: false,
  is_creating_contentCreatorInvite: false,
  is_deleting_contentCreatorInvite: false,
}
export interface contentCreatorInviteSliceState {
  contentCreatorInvite: ContentCreatorInvite[]
  selected_contentCreatorInvite?: string
  is_loading_contentCreatorInvite: boolean
  is_creating_contentCreatorInvite: boolean
  is_deleting_contentCreatorInvite: boolean
}
export const contentCreatorInviteSlice = createSlice({
  name: 'contentCreatorInvite',
  initialState,
  reducers: {
    setSelectedcontentCreatorInvite: (state, action) => {
      state.selected_contentCreatorInvite = action.payload
    },
    clearStatecontentCreatorInvite: (state) => {
      state.contentCreatorInvite = []
      state.is_loading_contentCreatorInvite = false
      state.is_creating_contentCreatorInvite = false
      state.is_deleting_contentCreatorInvite = false
    },
    mergecontentCreatorInvite: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_contentCreatorInvite = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.contentCreatorInvite = merge(
            state.contentCreatorInvite,
            payload,
          ) as any
        }
      }
    },

    add_contentCreatorInvite: (state, action) => {
      if (action.payload) {
        state.contentCreatorInvite = [
          ...state.contentCreatorInvite,
          action.payload,
        ]
      }
    },
    set_contentCreatorInvite: (state, action) => {
      let { key, value, id } = action.payload
      state.contentCreatorInvite = state.contentCreatorInvite.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadContentCreatorInvitesAsync.pending, (state) => {
      state.is_loading_contentCreatorInvite = true
    })
    builder.addCase(
      LoadContentCreatorInvitesAsync.fulfilled,
      (state, action) => {
        state.is_loading_contentCreatorInvite = false
        if (action.payload) {
          state.contentCreatorInvite = action.payload
        }
      },
    )
    builder.addCase(LoadContentCreatorInvitesAsync.rejected, (state) => {
      state.is_loading_contentCreatorInvite = false
    })
    builder.addCase(CreateContentCreatorInviteAsync.pending, (state) => {
      state.is_creating_contentCreatorInvite = true
    })
    builder.addCase(CreateContentCreatorInviteAsync.fulfilled, (state) => {
      state.is_creating_contentCreatorInvite = false
    })
    builder.addCase(CreateContentCreatorInviteAsync.rejected, (state) => {
      state.is_creating_contentCreatorInvite = false
    })
    builder.addCase(DeleteContentCreatorInviteAsync.pending, (state) => {
      state.is_deleting_contentCreatorInvite = true
    })
    builder.addCase(
      DeleteContentCreatorInviteAsync.fulfilled,
      (state, action) => {
        state.is_deleting_contentCreatorInvite = false
        if (state.contentCreatorInvite) {
          state.contentCreatorInvite = state.contentCreatorInvite.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteContentCreatorInviteAsync.rejected, (state) => {
      state.is_deleting_contentCreatorInvite = false
    })

    builder.addCase(
      autoThunks.accept_content_creator_invite.pending,
      (state) => {
        state.is_loading_contentCreatorInvite = true
      },
    )
    builder.addCase(
      autoThunks.accept_content_creator_invite.fulfilled,
      (state, action) => {
        state.is_loading_contentCreatorInvite = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.accept_content_creator_invite.rejected,
      (state) => {
        state.is_loading_contentCreatorInvite = false
      },
    )

    builder.addCase(autoThunks.get_content_creator_invite.pending, (state) => {
      state.is_loading_contentCreatorInvite = true
    })
    builder.addCase(
      autoThunks.get_content_creator_invite.fulfilled,
      (state, action) => {
        state.is_loading_contentCreatorInvite = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_content_creator_invite.rejected, (state) => {
      state.is_loading_contentCreatorInvite = false
    })

    builder.addCase(autoThunks.get_content_creator_invites.pending, (state) => {
      state.is_loading_contentCreatorInvite = true
    })
    builder.addCase(
      autoThunks.get_content_creator_invites.fulfilled,
      (state, action) => {
        state.is_loading_contentCreatorInvite = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_content_creator_invites.rejected,
      (state) => {
        state.is_loading_contentCreatorInvite = false
      },
    )

    builder.addCase(
      autoThunks.create_content_creator_invite.pending,
      (state) => {
        state.is_loading_contentCreatorInvite = true
      },
    )
    builder.addCase(
      autoThunks.create_content_creator_invite.fulfilled,
      (state, action) => {
        state.is_loading_contentCreatorInvite = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.create_content_creator_invite.rejected,
      (state) => {
        state.is_loading_contentCreatorInvite = false
      },
    )

    builder.addCase(
      autoThunks.delete_content_creator_invite.pending,
      (state) => {
        state.is_loading_contentCreatorInvite = true
      },
    )
    builder.addCase(
      autoThunks.delete_content_creator_invite.fulfilled,
      (state, action) => {
        state.is_loading_contentCreatorInvite = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.delete_content_creator_invite.rejected,
      (state) => {
        state.is_loading_contentCreatorInvite = false
      },
    )
  },
})

function handleResult(action: any, state: contentCreatorInviteSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_contentCreatorInvite = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.contentCreatorInvite = merge(
        state.contentCreatorInvite,
        payload,
      ) as any
    }
  }
}

export const {
  clearStatecontentCreatorInvite,
  setSelectedcontentCreatorInvite,
  set_contentCreatorInvite,
  mergecontentCreatorInvite,
  add_contentCreatorInvite,
} = contentCreatorInviteSlice.actions

export const get_contentCreatorInvite =
  (id?: string) =>
  (state: {
    contentCreatorInvite: {
      contentCreatorInvite: ContentCreatorInvite[]
    }
  }): ContentCreatorInvite | null => {
    let temp = state?.contentCreatorInvite?.contentCreatorInvite?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.contentCreatorInvite?.contentCreatorInvite[0] || null
  }
export const get_selected_contentCreatorInvite = (state: {
  contentCreatorInvite: contentCreatorInviteSliceState
}): ContentCreatorInvite | null => {
  let id = state?.contentCreatorInvite?.selected_contentCreatorInvite
  let temp = state?.contentCreatorInvite?.contentCreatorInvite?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_contentCreatorInvite = (state: {
  contentCreatorInvite: {
    contentCreatorInvite: ContentCreatorInvite[]
  }
}): ContentCreatorInvite[] => {
  let temp = state?.contentCreatorInvite?.contentCreatorInvite
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_contentCreatorInvite_busy = (state: {
  contentCreatorInvite: contentCreatorInviteSliceState
}) => {
  return (
    state?.contentCreatorInvite.is_deleting_contentCreatorInvite ||
    state?.contentCreatorInvite.is_loading_contentCreatorInvite ||
    state?.contentCreatorInvite.is_creating_contentCreatorInvite
  )
}
export const is_deleting_contentCreatorInvite_busy = (state: {
  contentCreatorInvite: contentCreatorInviteSliceState
}) => {
  return state?.contentCreatorInvite.is_deleting_contentCreatorInvite
}
export const is_loading_contentCreatorInvite_busy = (state: {
  contentCreatorInvite: contentCreatorInviteSliceState
}) => {
  return state?.contentCreatorInvite.is_loading_contentCreatorInvite
}
export const is_creating_contentCreatorInvite_busy = (state: {
  contentCreatorInvite: contentCreatorInviteSliceState
}) => {
  return state?.contentCreatorInvite.is_creating_contentCreatorInvite
}

export default contentCreatorInviteSlice.reducer
